var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8388 6.16916C10.8388 6.36883 10.6769 6.53069 10.4772 6.53069C10.2776 6.53069 10.1157 6.36883 10.1157 6.16916C10.1157 5.96948 10.2776 5.80762 10.4772 5.80762C10.6769 5.80762 10.8388 5.96948 10.8388 6.16916ZM5.99261 6.16916C5.99261 6.36883 5.83074 6.53069 5.63107 6.53069C5.4314 6.53069 5.26953 6.36883 5.26953 6.16916C5.26953 5.96948 5.4314 5.80762 5.63107 5.80762C5.83074 5.80762 5.99261 5.96948 5.99261 6.16916Z",
    fill: "#7D899D",
    stroke: "#DBAA2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 10.625H10.625M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z",
    stroke: "#DBAA2C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.625c0eb7.svg";
export { ForwardRef as ReactComponent };